var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registration-view"},[_vm._m(0),_vm._v(" "),_c('a',{staticClass:"btn btn--secondary btn--sm bottom-gap-sm registration-view__btn",attrs:{"href":_vm.registrationUrl,"target":"_blank"}},[_vm._v("Manage my registrations")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registration-view__header"},[_c('h2',{staticClass:"common__heading bottom-gap-lg"},[_vm._v("Registrations")])])
}]

export { render, staticRenderFns }